// JsFromRoutes CacheKey 6f51fa96f54e85cdd5a25217fdf2ef9b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/integrations/:type'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:org_nano_id/integrations/:type'),
}
